import React from 'react';
import {useMediaPredicate} from "react-media-hook";

export const DEVICE_TYPES = {
    SMALL_MOBILE: "small_mobile",
    MOBILE: "mobile",
    FABLET: "fablet",
    TABLET: "tablet",
    SMALL_PC: "small_pc",
    MEDIUM_PC: "medium_pc",
    LARGE_PC: "large_pc"
};

function Media() {
    const isSmallMobile = useMediaPredicate("(max-width: 380px)");
    const isMobile = useMediaPredicate("(min-width: 381px) and (max-width: 500px)");
    const isFablet = useMediaPredicate("(min-width: 501px) and (max-width: 700px)");
    const isTablet = useMediaPredicate("(min-width: 701px) and (max-width: 991px)");
    const isSmallPc = useMediaPredicate("(min-width: 992px) and (max-width: 1300px)");
    const isMediumPc = useMediaPredicate("(min-width: 1301px) and (max-width: 1600px)");
    const isLargePc = useMediaPredicate("(min-width: 1601px)");

    if (isLargePc && !isMediumPc && !isSmallPc && !isTablet && !isFablet && !isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.LARGE_PC);
    } else if (isMediumPc && !isSmallPc && !isTablet && !isFablet && !isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.MEDIUM_PC);
    } else if (isSmallPc && !isTablet && !isFablet && !isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.SMALL_PC);
    } else if (isTablet && !isFablet && !isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.TABLET);
    } else if (isFablet && !isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.FABLET);
    } else if (isMobile && !isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.MOBILE);
    } else if (isSmallMobile) {
        localStorage.setItem("device_type", DEVICE_TYPES.SMALL_MOBILE);
    }
    return (<></>);
}

export function getDeviceType() {
    return localStorage.getItem("device_type");
}

//////////////////////////////////////////////////////////////////

export function IsLargePc() {
    return (getDeviceType() === DEVICE_TYPES.LARGE_PC);
}

export function IsMediumPc() {
    return (getDeviceType() === DEVICE_TYPES.MEDIUM_PC);
}

export function IsSmallPc() {
    return (getDeviceType() === DEVICE_TYPES.SMALL_PC);
}

export function IsTablet() {
    return (getDeviceType() === DEVICE_TYPES.TABLET);
}

export function IsFablet() {
    return (getDeviceType() === DEVICE_TYPES.FABLET);
}

export function IsMobile() {
    return (getDeviceType() === DEVICE_TYPES.MOBILE);
}

export function IsSmallMobile() {
    return (getDeviceType() === DEVICE_TYPES.SMALL_MOBILE);
}

//////////////////////////////////////////////////////////////////

export function IsSM() {
    return IsSmallMobile();
}

export function IsNotSM() {
    return !IsSM();
}

export function IsM() {
    return IsMobile();
}

export function IsNotM() {
    return !IsM();
}

export function IsF() {
    return IsFablet();
}

export function IsNotF() {
    return !IsF();
}

export function IsT() {
    return IsTablet();
}

export function IsNotT() {
    return !IsT();
}

export function IsSP() {
    return IsSmallPc();
}

export function IsNotSP() {
    return !IsSP();
}

export function IsMP() {
    return IsMediumPc();
}

export function IsNotMP() {
    return !IsMP();
}

export function IsLP() {
    return IsLargePc();
}

export function IsNotLP() {
    return !IsLP();
}

//////////////////////////////////////////////////////////////////

export function IsLP_MP() {
    return IsLP() || IsMP();
}

export function IsLP_MP_SP() {
    return IsLP() || IsMP() || IsSP();
}

export function IsNotLP_MP_SP() {
    return !IsLP_MP_SP();
}

export function IsNotM_SM() {
    return !(IsSM() || IsM());
}

export function IsT_M_SM() {
    return IsT() || IsM() || IsSM();
}

export function IsT_F_M_SM() {
    return IsT() || IsF() || IsM() || IsSM();
}

export function IsLP_MP_SP_T() {
    return IsLP_MP_SP() || IsT();
}

export function IsSM_M_F() {
    return IsM() || IsSM() || IsF();
}

export function IsM_SM() {
    return IsM() || IsSM();
}

//////////////////////////////////////////////////////////////////

export function getProductHeaderWidth(hasRelated) {
    if (hasRelated) {
        return IsLP() ? "15%" : IsMP() ? "15%" : "22%";
    } else {
        return IsLP() ? "10%" : IsMP() ? "13%" : "16%";
    }
}

export function getProductListWidth(hasRelated) {
    if (hasRelated) {
        return IsLP() ? "84.5%" : IsMP() ? "84.5%" : "77.5%";
    } else {
        return IsLP() ? "89.5%" : IsMP() ? "86.5%" : "83.5%";
    }
}

export function getAddressSize() {
    return IsLargePc() ? 100 :
        IsMediumPc() ? 90 :
            IsSmallPc() ? 70 :
                IsTablet() ? 75 :
                    IsFablet() ? 55 :
                        IsMobile() ? 50 : 40;
}

export function getLoadingSize() {
    return IsLargePc() ? 90 :
        IsMediumPc() ? 80 :
            IsSmallPc() ? 70 :
                IsTablet() ? 60 :
                    IsFablet() ? 50 :
                        IsMobile() ? 40 : 30;
}

export function getFontSize() {
    return IsLargePc() ? "15px" :
        IsMediumPc() ? "14px" :
            IsTablet() ? "13px" :
                IsFablet() ? "12px" :
                    IsMobile() ? "12px" : "11px";
}

export function getTitleFontSize() {
    return IsLargePc() ? "24px" :
        IsMediumPc() ? "24px" :
            IsTablet() ? "13px" :
                IsFablet() ? "12px" :
                    IsMobile() ? "12px" : "11px";
}
export function getTextViewHeight() {
    return IsLargePc() ? "4em" :
        IsMediumPc() ? "3em" :
            IsSmallPc() ? "2.8em" :
                IsTablet() ? "2.5em" :
                    IsFablet() ? "2.5em" :
                        IsMobile() ? "2.3em" : "2.2em";
}

export function getSmallTextViewHeight() {
    return IsLargePc() ? "2.5em" :
        IsMediumPc() ? "2.3em" :
            IsSmallPc() ? "2.3em" :
                IsTablet() ? "2.3em" :
                    IsFablet() ? "2.3em" :
                        IsMobile() ? "2.5em" : "2.3em";
}

export function getButtonHeight() {
    return IsLargePc() ? "4em" :
        IsMediumPc() ? "3em" :
            IsSmallPc() ? "2.8em" :
                IsTablet() ? "2.5em" :
                    IsFablet() ? "2.5em" :
                        IsMobile() ? "2.3em" : "2em";
}

export function getOffsetWidth() {
    return IsLargePc() ? "85%" :
        IsMediumPc() ? "85%" :
            IsSmallPc() ? "80%" :
                IsTablet() ? "85%" :
                    IsFablet() ? "85%" :
                        IsMobile() ? "85%" : "80%";
}

export function getProductListSlidePerView(hasRelated, type) {
    let slidePerView;
    if (hasRelated) {
        if (type === "1") {
            if (IsLP()) {
                slidePerView = 4
            } else if (IsMP()) {
                slidePerView = 3.5
            } else {
                slidePerView = 2.5
            }
        } else {
            if (IsLP()) {
                slidePerView = 4
            } else if (IsMP()) {
                slidePerView = 3.5
            } else {
                slidePerView = 2.5
            }
        }
    } else {
        if (type === "1") {
            if (IsLP()) {
                slidePerView = 7
            } else if (IsMP()) {
                slidePerView = 5.5
            } else {
                slidePerView = 4.2
            }
        } else {
            if (IsLP()) {
                slidePerView = 5.5
            } else if (IsMP()) {
                slidePerView = 4.5
            } else {
                slidePerView = 3.45
            }
        }
    }
    return slidePerView;
}


export default Media